var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-panel"},[_c('div',{staticClass:"m-panel-bar"},[_c('div',{staticClass:"m-panel-bar-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"m-panel-body"},[_c('Echart',{ref:"option",staticStyle:{"height":"100%"},attrs:{"options":_vm.option}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }